import { useEffect, useState } from "react";
import { Col, Row, Alert, Spinner } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiCardRemoveOutline, mdiClipboardPulseOutline, mdiPulse } from "@mdi/js";
import moment from "moment";
import "moment/locale/pt-br";

import { formatarTempoChecagem } from "../../utils/tempo";
import { getSaudeIcon, ordenarPorSaude } from "../../utils/saude";
import { useGetDashboard } from "../../config/swagger";

import DashboardCard from "../../components/DashboardCard";
import LayoutSingle from "../../components/LayoutSingle";

moment.locale("pt-br");

export default function Status() {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const token = searchParams.get("t");
	const [enable, setEnable] = useState(false);

	const queryDashboard = useGetDashboard({ query: { enabled: !!token && enable } });

	useEffect(() => {
		if (token) {
			sessionStorage.setItem("user", JSON.stringify({ token: token }));
			setEnable(true);
		}
	}, [token]);

	return (
		<LayoutSingle header={"Status"}>
			<h5 className="mt-4 mb-4 d-flex align-items-center fw-light">
				<div className="d-flex align-items-center">
					<Icon path={mdiClipboardPulseOutline} size={1} className="me-2" />
					Dashboard
					{queryDashboard.isFetching && <Spinner size="sm" className="ms-2" variant="secondary" />}
				</div>
			</h5>

			<Row className="mt-3 mb-4">
				{queryDashboard.isLoading && (
					<>
						<Col md={4}>
							<DashboardCard title="&nbsp;" footer="&nbsp;" icon={mdiPulse} loading={true} />
						</Col>
						<Col md={4}>
							<DashboardCard title="&nbsp;" footer="&nbsp;" icon={mdiPulse} loading={true} />
						</Col>
						<Col md={4}>
							<DashboardCard title="&nbsp;" footer="&nbsp;" icon={mdiPulse} loading={true} />
						</Col>
					</>
				)}

				{!queryDashboard.isLoading && (
					<>
						{queryDashboard.data?.Result !== 1 && (
							<Col md={12}>
								<Alert variant="secondary" className="text-center">
									{queryDashboard.data?.Message || "Problema na operação. Tente novamente mais tarde"}
								</Alert>
							</Col>
						)}

						{queryDashboard.data?.Result === 1 && (
							<>
								{!queryDashboard.data?.Data?.length ? (
									<Alert variant="light" className="text-center p-4 d-flex justify-content-center align-items-center">
										<Icon path={mdiCardRemoveOutline} size={1} className="me-2" />
										Nenhum registro encontrado
									</Alert>
								) : (
									ordenarPorSaude(queryDashboard.data.Data).map((item, index) => {
										const iconClass = getSaudeIcon(item.saude);
										return (
											<Col md={4} key={index}>
												<DashboardCard
													icon={mdiPulse}
													iconClass={iconClass}
													title={item.nome || "Sem nome"}
													value={`${item.monitoresGoods || "0"}`}
													valueDescription={`\u00A0/ ${item.monitores || "0"}`}
													footer={formatarTempoChecagem(item.dataUltimaChecagem || "", item.ultimaLatencia || "")}
													onClick={() => {
														navigate(`/statusGrupo/${item.id}?t=${token}`);
													}}
												/>
											</Col>
										);
									})
								)}
							</>
						)}
					</>
				)}
			</Row>
		</LayoutSingle>
	);
}
